import React from "react";

const pillars = [
  {
    id: "striking",
    num: "01",
    title: "Striking for MMA",
    tag: "Boxing · Muay Thai · Karate",
    image: "https://images.pexels.com/photos/28560751/pexels-photo-28560751.jpeg",
    body:
      "Pure striking — infusing techniques from boxing, Muay Thai and karate. Crisp hands, heavy kicks, tight clinch work and the footwork your fight actually needs, drilled against real resistance.",
    bullets: [
      "Pad rounds with real resistance",
      "Tempo drills → live sparring progression",
      "Fight IQ: range, feints, defensive layering",
    ],
  },
  {
    id: "grappling",
    num: "02",
    title: "Grappling for MMA",
    tag: "Wrestling · Clinch · Scrambles",
    image: "https://images.pexels.com/photos/5485525/pexels-photo-5485525.jpeg",
    body:
      "Takedowns that land. Top pressure that drowns. Our grappling curriculum is built for cage reality — clinch entries, chain wrestling and control from the shot to the finish.",
    bullets: [
      "Takedowns & takedown defence",
      "Clinch control & cage wrestling",
      "Scramble chains & top-position finishes",
    ],
  },
];

export default function Pillars() {
  return (
    <section
      id="training"
      data-testid="pillars-section"
      className="relative py-28 md:py-36 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#d4af37]" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
              Two Pillars · One Fighter
            </span>
          </div>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9]">
            What <span className="text-[#d4af37]">MMA</span> <br />
            actually is.
          </h2>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-2xl">
            Mixed Martial Arts is the fusion of striking and grappling — tested
            against a resisting opponent. At Full Circle we don't water it down.
            Every session sharpens one of the two pillars that decide a fight.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {pillars.map((p) => (
            <article
              key={p.id}
              data-testid={`pillar-${p.id}`}
              className="group relative bg-[#0f0f0f] border border-white/10 hover:border-[#d4af37]/60 transition-colors"
            >
              <div className="relative aspect-[16/11] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f0f] via-black/30 to-transparent" />
                <div className="absolute top-4 left-4 font-heading text-[#d4af37] text-5xl">
                  {p.num}
                </div>
                <div className="absolute bottom-4 left-6 right-6">
                  <div className="text-xs uppercase tracking-[0.25em] text-white/70">
                    {p.tag}
                  </div>
                  <h3 className="font-heading text-white text-3xl md:text-4xl uppercase leading-none mt-1">
                    {p.title}
                  </h3>
                </div>
              </div>

              <div className="p-8">
                <p className="text-white/70 leading-relaxed">{p.body}</p>
                <ul className="mt-6 space-y-2">
                  {p.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-3 text-sm text-white/80">
                      <span className="mt-1.5 w-2 h-2 bg-[#d4af37] shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
